import { Schema } from "../../../core/render/logic/Markdoc/index";

export const issue: Schema = {
	render: "Issue",
	attributes: {
		id: { type: String },
	},
};
